//全局过滤方法
const vFilter = {
  numFilter: function (value) {
    // 截取当前数据到小数点后两位
    let realVal = Number(value).toFixed(2)
    return realVal
  },
  //金额格式化，3,245.55
  money: function (val) {
    val = (val + '') == 'null' ? '' : val;
    val = (val + '').toString().replace(/\$|\,/g, '');
    if (val == '') {
      return '';
    }
    if (isNaN(val)) {
      val = "0";
    }
    let sign = (val == (val = Math.abs(val)));
    val = Math.floor(val * 100 + 0.50000000001);
    let cents = val % 100;
    val = Math.floor(val / 100).toString();
    if (cents < 10) {
      cents = "0" + cents
    }
    for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
      val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
    }

    return (((sign) ? '' : '-') + val + '.' + cents);
  },
  //时间格式化
  formatDate: function (date, format) {
    if (!date) return;
    date = date.replace('T', ' ');
    if (!format) format = "yyyy-MM-dd";
    switch (typeof date) {
      case "string":
        date = new Date(date.replace(/-/g, "/"));
        break;
      case "number":
        date = new Date(date);
        break;
    }

    if (!date instanceof Date) return;
    var dict = {
      "yyyy": date.getFullYear(),
      "M": date.getMonth() + 1,
      "d": date.getDate(),
      "H": date.getHours(),
      "m": date.getMinutes(),
      "s": date.getSeconds(),
      "MM": ("" + (date.getMonth() + 101)).substr(1),
      "dd": ("" + (date.getDate() + 100)).substr(1),
      "HH": ("" + (date.getHours() + 100)).substr(1),
      "mm": ("" + (date.getMinutes() + 100)).substr(1),
      "ss": ("" + (date.getSeconds() + 100)).substr(1)
    };
    let t = format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function () {
      return dict[arguments[0]];
    });
    return t;
  },
  //计算两个数相乘，避免出现很多小数
  accMul: function (arg1, arg2) {
    let m = 0, s1 = arg1 + '', s2 = arg2 + '';
    try {
      m += s1.split(".")[1].length
    } catch (e) { }
    try {
      m += s2.split(".")[1].length
    } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  },
  getNowFormatDate: function (format) {
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate
      + " " + date.getHours() + seperator2 + date.getMinutes()
      + seperator2 + date.getSeconds();
    if (format) {
      return this.formatDate(currentdate, format);
    }
    return currentdate;
  }
}
export default vFilter



// WEBPACK FOOTER //
// ./src/common/js/filter.js